import { Button } from "components/Button/Button";
import Datepicker from "components/DatePicker/DatePicker";
import { Loading } from "components/Loading/loading";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { useEffect, useState } from "react";
import { MessageType } from "types/enum";
import {
  FloorWithRoundingPlace,
  RoundWithRoundingPlace,
  trans,
  uuidv4,
} from "utils/helpers";
import { ItemsForSell } from "../../Sales/components/ItemsForSell/ItemsForSell";
import { PriceDetails } from "../../Sales/components/PriceDetails";
import { getPriceListDetail } from "./api";
import ItemSelector from "./components/ItemRequestDetail/ItemSelector";
import PriceFields from "./components/ItemRequestDetail/PriceFields";
import { ItemRequestDetailType } from "./type";
import { WarehouseTreeForm } from "./components/WarehouseTreeForm/WarehouseTreeForm";
import { Items } from "../WarehouseItem/ItemTreeForm";
import { ItemStockList } from "../WarehouseIO/components/ItemStockList";
import { getWarehouseItemDetail } from "../WarehouseItem/api";

interface ItemRequestFormProps {
  onHide: () => void;
  ItemRequestDetailCallBack?: (e: any) => void;
  selectedObj?: any;
  docsClassification?: any;
  mode: any;
  priceList?: any;
  lastWarehouse?: any;
  invoiceConstraint?: any;
  setLastWarehouse: (e: any) => void;
  personId?: any;
  currency?: any;
  ItemRequestId?: any;
  jobId;
}

export const ItemRequestDetailForm = ({
  lastWarehouse = null,
  invoiceConstraint,
  setLastWarehouse,
  priceList,
  selectedObj,
  docsClassification,
  mode,
  onHide,
  ItemRequestDetailCallBack,
  personId,
  currency,
  ItemRequestId,
  jobId,
}: ItemRequestFormProps) => {
  const [resetForm, setResetForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userChanges, setUserChanges] = useState({});
  const [expireDate, setExpireDate] = useState<any>(null);
  const [showTree, setShowTree] = useState(false);
  const [showWarehouseTree, setShowWarehouseTree] = useState(false);
  const [priceListDetail, setPriceListDetail] = useState<any>([]);
  const [detailPriceData, setDetailPriceData] = useState<any>({
    Price: 0,
    Discount: "",
    SubTotalPrice: 0,
    TaxRate: "0",
    Qty1: mode !== "create" ? selectedObj?.Qty1 : 1,
    Qty2: mode !== "create" ? selectedObj?.Qty2 : 1,
  });
  const [itemData, setItemData] = useState<any>(null);
  const [warehouseData, setWarehouseData] = useState(lastWarehouse);
  const [dictionaryName, setDictionaryName] = useState<any>({});
  const [saveExit, setSaveExit] = useState(false);
  const [rate, setRate] = useState<any>(1);
  const [firstQty, setFirstQty] = useState<any>(null);
  const [numberOfSalesUnit, setNumberOfSalesUnit] = useState(1);
  const [showPriceListDetail, setShowPriceListDetail] = useState<any>(false);
  const [savedNewQty, setSavedNewQty] = useState(null);
  const [itemStokList, setItemStokList] = useState<any>();

  const handleItemRequestFormSubmit = async (event) => {
    event.preventDefault();
    const data: ItemRequestDetailType = {
      Id: mode !== "create" ? selectedObj?.Id : uuidv4(),
      ItemRequestId: ItemRequestId,
      SourceId: mode !== "create" ? selectedObj?.SourceId : undefined,
      SourceData: mode !== "create" ? selectedObj?.SourceData : undefined,
      // IsAbsoluteUnitConversionRatio	: selectedObj.IsAbsoluteUnitConversionRatio	,
      ItemId: itemData?.Id,
      WarehouseId: warehouseData?.WarehouseId,
      WarehouseDetailId: warehouseData?.WarehouseDetailId,
      Unit1Id: event.target.Unit1Id?.value || null,
      Unit2Id: event.target.Unit2Id?.value || null,
      SalesUnitId: detailPriceData.SalesUnitId,
      ItemCode: itemData?.Code ? itemData?.Code : itemData?.ItemCode,
      Item: itemData?.Item,
      Qty1: +event.target.Qty1?.value,
      Unit1: dictionaryName?.Unit1 || null,
      Qty2: +event.target.Qty2?.value,
      Unit2: dictionaryName?.Unit2 || null,
      ExpireDate:
        itemData?.HasExpireDate || itemStokList?.ExpireDate
          ? itemStokList?.ExpireDate
          : null,
      PartyNo:
        itemData?.HasProductTracking || itemStokList?.PartyNo
          ? itemStokList?.PartyNo
          : null,

      ConversionRatio: rate,
      ItemTechnicalCode: event.target.ItemTechnicalCode?.value,

      CargoWeight: +event.target?.CargoWeight?.value || 0,
      Description: event.target.Description?.value,
      Warehouse: warehouseData.WarehouseTitle,
      WarehouseDetail: warehouseData?.WarehouseDetail,
      IsAbsoluteUnitConversionRatio:
        priceListDetail[0]?.IsAbsoluteUnitConversionRatio,
    };

    ItemRequestDetailCallBack?.(data) && resetFormIfNeeded();
    setLastWarehouse(warehouseData);
    // ItemRequestDetailCallBack?.(data) ;
  };


  const resetFormIfNeeded = () => {
    if (mode === "create") {
      setResetForm(true);
      setItemData(null);
      setUserChanges({});
      setDetailPriceData({
        Price: 0,
        Discount: 0,
        SubTotalPrice: 0,
        Qty1: 1,
        Qty2: 1,
        TaxRate: 0,
      });
      setPriceListDetail([]);
    }
    sessionStorage.setItem("changingforms", "false");
    if (saveExit) onHide();
  };

  const handleItemCode = (obj, isLeafSelected) => {
    if (obj.IsLeaf || isLeafSelected) {
      setItemData({
        Code: obj.ItemCode,
        Id: obj.Id,
        TechnicalCode: obj.ItemTechnicalCode,
        ItemStockList: obj.ItemStockList,
        HasProductTracking: obj.HasProductTracking,
        Item: obj.ItemDescription,
        HasExpireDate: obj.HasExpireDate,
        
      });
      setSavedNewQty(null);
      // fetchPriceListDetail(obj.Id);
      setShowTree(false);
      setDetailPriceData({
        ...obj,
        Unit1Id: obj.MainUnitId,
        Unit2Id: obj.StatisticalUnitId,
        Unit2: obj.Unit2,
        Unit1: obj.Unit1,
        Qty1: obj.QtyMainUnit,
        Qty2: obj.QtyStatisticalUnit,
      });
      setPriceListDetail([
        {
          ...obj,
          Unit1Id: obj.MainUnitId,
          Unit2Id: obj.StatisticalUnitId,
          Unit2: obj.Unit2,
          Unit1: obj.Unit1,
          Qty1: obj.QtyMainUnit,
          Qty2: obj.QtyStatisticalUnit,
        },
      ]);

      if (mode === "edit") {
        setShowPriceListDetail(true);
      }
    } else {
      // Toast('msg_itemleafisnotselected', 'error');
      Toast("msg_itemleafisnotselected", MessageType.error);
    }
  };

  const handleWarehouseSelection = (obj) => {
    setWarehouseData(obj);
    setShowWarehouseTree(false);
  };

  const updateQuantity = async (
    newQty,
    priceListArray = [],
    QtyInChange = null
  ) => {
    if (
      (QtyInChange == null &&
        priceListDetail[priceListDetail.length - 1]?.SalesUnitMaxOrderQty) ||
      (QtyInChange == "Qty" + numberOfSalesUnit &&
        priceListDetail[priceListDetail.length - 1].SalesUnitMaxOrderQty)
    ) {
      //when we get priceList, we should detect that whether newQty is more than SalesUnitMaxOrderQty and change Qty to SalesUnitMaxOrderQty
      newQty =
        priceListDetail[priceListDetail.length - 1].SalesUnitMaxOrderQty <=
        newQty
          ? priceListDetail[priceListDetail.length - 1].SalesUnitMaxOrderQty
          : newQty;
    }
    if (
      (firstQty == null || !(priceListDetail.length > 0)) &&
      priceList?.HasDetailRange &&
      mode === "edit" &&
      ((numberOfSalesUnit == 1 && newQty !== selectedObj.Qty1) ||
        (numberOfSalesUnit == 2 && newQty !== selectedObj.Qty2))
    ) {
      setSavedNewQty(newQty); //to countinue with newQty and prevent to reset newQty
      // چون که شرط  رترن میکنه و از تابع خارج میشه مقدار جدید (نیوکیوتیوای ) ذخیره نمیشه  و مقدار قبلیشو میگیره و باید مقدار جدیدشو حفظ کنیم

      setFirstQty(selectedObj?.ItemId);
      // fetchPriceListDetail(itemData?.Id??selectedObj?.ItemId)
    } //in create mode uses itemData and edit,view mode uses selectedObj?.ItemId

    let newPriceData = await calculatePriceData(newQty, priceListArray);

    setDetailPriceData({
      ...newPriceData,
      Qty1: RoundWithRoundingPlace(
        (numberOfSalesUnit === 1 ? 1 : priceListDetail[0]?.ConversionRatio) *
          newQty,
        priceListDetail[0]?.Qty1RoundingPlace
      ),
      Qty2: RoundWithRoundingPlace(
        newQty /
          (numberOfSalesUnit === 2 ? 1 : priceListDetail[0]?.ConversionRatio),
        priceListDetail[0]?.Qty2RoundingPlace
      ),
    });
  };

  const calculatePriceData = (newQty, priceListArray) => {
    const currentPriceList = !!priceListArray.length
      ? priceListArray
      : priceListDetail;
    let matchedPriceData = findMatchingPriceData(currentPriceList, newQty);
    matchedPriceData = matchedPriceData
      ? matchedPriceData
      : {
          ...currentPriceList[0],
          Unit2Price: 0,
          Unit1Price: 0,
          SalesUnitPrice: 0,
          DiscountPercent: 0,
        };

    return {
      ...matchedPriceData,
      UnitPrice:
        matchedPriceData?.UnitPrice || matchedPriceData?.UnitPrice == 0
          ? matchedPriceData?.UnitPrice
          : matchedPriceData?.SalesUnitId === matchedPriceData?.Unit1Id
          ? matchedPriceData?.Unit2Price
          : matchedPriceData?.Unit1Price,
      Price: calculateDiscountedPrice(newQty, matchedPriceData),
      Discount: calculateDiscount(newQty, matchedPriceData),
      //to set TaxRate when pricelist is manual then we sould use detailPriceData.TaxRate because we nedd to save taxrate when unitprice are changing and currentPriceList[0] is 0 because was set at first
      TaxRate:
        docsClassification?.CalculateTax ||
        (docsClassification?.CalculateTax == null && invoiceConstraint.HasTax)
          ? currentPriceList[0]?.TaxRate
          : 0,
      DiscountPercent: +matchedPriceData?.DiscountPercent,
      SubTotalPrice: newQty * matchedPriceData?.SalesUnitPrice,
    };
  };

  const findMatchingPriceData = (priceList, qty) =>
    priceList.find(
      (e) =>
        (e.SalesUnitMaxOrderQty == null || +e.SalesUnitMaxOrderQty >= qty) &&
        +e.SalesUnitMinOrderQty <= qty
    );

  const calculateDiscountedPrice = (qty, priceData) => {
    return RoundWithRoundingPlace(
      qty *
        ((priceData?.SalesUnitPrice * (100 - priceData?.DiscountPercent)) /
          100),
      0
    );
  };

  const calculateDiscount = (qty, priceData) => {
    return RoundWithRoundingPlace(
      qty * ((priceData?.SalesUnitPrice * priceData?.DiscountPercent) / 100),
      0
    );
  };

  const fetchPriceList = async (itemId = null, code = null) => {
    try {
      const { Data } = await getWarehouseItemDetail(
        itemId,
        selectedObj?.WarehouseId,
        selectedObj?.WarehouseDetailId,
        false
      );

      const newPriceListDetails=Data.map((item)=>{
        return {...item,
          SalesUnitMaxOrderQty:item.SalesUnitId === item.MainUnitId?item.Unit1MaxOrderQty:item.Unit2MaxOrderQty,
          SalesUnitMinOrderQty:item.SalesUnitId === item.MainUnitId?item.Unit1MinOrderQty:item.Unit2MinOrderQty,
          MaxOrderQty:item.SalesUnitId === item.MainUnitId?item.Unit2MaxOrderQty:item.Unit1MaxOrderQty,
          MinOrderQty:item.SalesUnitId === item.MainUnitId?item.Unit2MinOrderQty:item.Unit1MinOrderQty,
          SalesUnitPrice:item.SalesUnitId === item.MainUnitId?item.Unit1Price:item.Unit2Price,
          SalesUnitId:item.SalesUnitId,
          SalesUnitDiscount:item.SalesUnitId === item.MainUnitId?item.Unit1Discount:item.Unit2Discount,
          Unit1Id:item.MainUnitId,
          Unit2Id:item.StatisticalUnitId
          //تعیین واحد فروش،کمترین و بیشترین مقدار فروش و کمترین و بیشترین مقدار واحد قیمت ، واحد اول و دوم
          //Determining the sales unit,because we use sales unit for countinuing programm and doing calculate
        }
      })
      return newPriceListDetails
    } catch {}
  };

  const updatePriceListDetails = async (
    data,
    withPriceListDetail = true,
    useSelectedObj = false
  ) => {
    const [firstItem] = useSelectedObj ? [selectedObj] : data;


    let newPriceListDetails =
      mode != "view" && !jobId ? fetchPriceList(firstItem?.ItemId) :data as any
    setRate(firstItem?.ConversionRatio);
    if (withPriceListDetail) setPriceListDetail(data);
    setItemData({
      ...itemData,
      Item: firstItem?.Item ? firstItem?.Item : firstItem?.ItemDescription,
      Id: firstItem?.ItemId,
      Code: firstItem?.ItemCode ? firstItem?.ItemCode : firstItem?.Code,
      ItemStockList: newPriceListDetails[0]?.ItemStockList,
      HasProductTracking: newPriceListDetails[0]?.HasProductTracking,
      HasExpireDate: newPriceListDetails[0]?.HasExpireDate,
    });
  };

  const cancel = () => {
    if (sessionStorage.getItem("changingforms") === "true") {
      // Toast('modalclosemessage', 'warning', 'alertWithoutClose', () => {
      //   sessionStorage.setItem('changingforms', 'false');
      //   setUserChanges({});
      //   onHide();
      // });
      Toast("modalclosemessage", MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        onHide();
      });
    } else {
      onHide();
    }
  };

  useEffect(() => {
    if (resetForm) setResetForm(false);
  }, [resetForm]);

  const initializeFormWithSelectedObject = () => {
    setWarehouseData({
      WarehouseId: selectedObj.WarehouseId,
      WarehouseDetailId: selectedObj?.WarehouseDetailId,
      Title: selectedObj.WarehouseDetail
        ? `${selectedObj.Warehouse},${selectedObj.WarehouseDetail}`
        : selectedObj.Warehouse,
    });

    setDetailPriceData({
      ...selectedObj,
      UnitPrice:
        selectedObj.SalesUnitId === selectedObj.Unit1Id
          ? selectedObj?.Unit2Price
          : selectedObj?.Unit1Price,
      TaxRate:
        docsClassification?.CalculateTax ||
        (docsClassification?.CalculateTax == null && invoiceConstraint.HasTax && mode!='view') || mode=='view'
          ? selectedObj.TaxRate
          : 0,
    });
    updatePriceListDetails(
      [
        {
          ...selectedObj,
          SalesUnitMaxOrderQty: null,
          SalesUnitMinOrderQty: 0,
          MaxOrderQty: null,
          MinOrderQty: 0,
          SalesUnitPrice:
            selectedObj.SalesUnitId === selectedObj.Unit1Id
              ? selectedObj.Unit1Price
              : selectedObj.Unit2Price,
          SalesUnitId: selectedObj.SalesUnitId,
          SalesUnitDiscount: selectedObj.Discount,
        },
      ],
      true,
      true
    );
  };

  
  useEffect(() => {
    if (selectedObj && mode !== "create") {
      initializeFormWithSelectedObject();
    }
  }, []);

  return (
    <div className="card " style={{ flexDirection: "row" }}>
      {showTree && (
        <ModalForm
          mode={mode}
          title="ItemTree"
          onHide={() => setShowTree(false)}
          show={showTree}
        >
          <Items
            fetchItem={true}
            warehouseId={warehouseData?.WarehouseId}
            warehouseDetailId={warehouseData?.WarehouseDetailId}
            onHide={() => {
              setShowTree(false);
            }}
            itemCodeHandeler={handleItemCode}
          />
        </ModalForm>
      )}
      {showWarehouseTree && (
        <ModalForm
          mode={mode}
          title="warehouses"
          onHide={() => setShowWarehouseTree(false)}
          show={showWarehouseTree}
        >
          <WarehouseTreeForm
            onHide={() => {
              setShowWarehouseTree(false);
            }}
            WarehouseIdHandeler={handleWarehouseSelection}
          />
        </ModalForm>
      )}
      <div style={{ flexWrap: "nowrap" }} className="card-body row">
        <div
          className={`card-body ${
            !!priceListDetail.length
              ? "col-12 col-md-7 col-lg-8 col-xl-9"
              : "col-12"
          }`}
        >
          {loading ? (
            <div className="container-fluid">
              <form onSubmit={handleItemRequestFormSubmit}>
                <ItemSelector
                  mode={mode}
                  resetForm={resetForm}
                  setWarehouseData={setWarehouseData}
                  setDetailPriceData={setDetailPriceData}
                  fetchPriceListDetail={() => {}}
                  setUserChanges={(e) => {
                    setUserChanges({ ...userChanges, ...e });
                  }}
                  setShowTree={setShowTree}
                  setItemData={setItemData}
                  warehouseData={warehouseData}
                  detailPriceData={detailPriceData}
                  itemData={itemData}
                  jobId={jobId}
                />

                <PriceFields
                  mode={mode}
                  resetForm={resetForm}
                  setUserChanges={(e) => {
                    setUserChanges({ ...userChanges, ...e });
                  }}
                  numberOfSalesUnit={numberOfSalesUnit}
                  priceList={priceList}
                  priceListDetail={priceListDetail}
                  Constraint={invoiceConstraint}
                  rate={rate}
                  setRate={setRate}
                  detailPriceData={detailPriceData}
                  setPriceListDetail={setPriceListDetail}
                  updateQuantity={updateQuantity}
                  setDictionaryName={setDictionaryName}
                  jobId={jobId}

                />

                {/* {itemData?.HasProductTracking ||
                  (itemData?.HasExpireDate && (
                    <ItemStockList
                      sendDataCallBack={(obj) => setItemStokList(obj)}
                      defaultValue={itemData}
                      data={itemData}
                      mode={"view"}
                    />
                  ))} */}
                <div className="row justify-content-end">
                  <div className="col-12">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxType="textarea"
                      textboxName="Description"
                      minHeight={1}
                      labelText="Remarks"
                      defaultValue={
                        mode != "create" ? selectedObj?.Description : null
                      }
                      resetForm={resetForm}
                      mode={jobId?'view':mode}

                      required={false}
                      maxLength={150}
                      letterCounter={true}
                    />
                  </div>
                </div>
                <>
                  {mode != "view" ? (
                    <div className="col-lg-12 mt-1 btns_form">
                      {mode === "create" && (
                        <Button value="save" btnType="submit" />
                      )}
                      <Button
                        value="SaveAndClose"
                        btnType="submit"
                        onClick={() => {
                          setSaveExit(true);
                        }}
                      />
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  ) : (
                    <div className="col-lg-12 mt-1 btns_form">
                      <Button
                        btnType="primary"
                        value="close"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  )}
                </>
              </form>
            </div>
          ) : (
            <Loading />
          )}
        </div>
        {!!priceListDetail.length &&
          priceList?.HasDetailRange &&
          (mode === "create" || (mode === "edit" && showPriceListDetail)) && (
            <PriceDetails priceListDetail={priceListDetail} />
          )}
      </div>
    </div>
  );
};
